module.exports = __webpack_public_path__ + "static/media/avaliacao-aprendizagem-400x225.d8377249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avaliacao-aprendizagem-400x225.jpg
// module id = 688
// module chunks = 0